<template>
  <div class="wrap">
    <v-card-title>
      <span class="headline">Создание формы</span>
    </v-card-title>
    <v-card-text>
      <Form @submit="create" />
    </v-card-text>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import errors from "@/mixins/errors";
import { API_URL_PREFIX } from "@/config/consts";
import Form from "./Form";
import { mapGetters } from "vuex";

export default {
  components: {
    Form
  },
  mixins: [errors],
  data() {
    return {
      multiLine: true,
      snackbar: false,
      errorText: ""
    };
  },
  computed: {
    ...mapGetters(["getErrorText"])
  },
  methods: {
    async create(form) {
      form.landing = this.getCurrentLandingId();
      try {
        const { data } = await this.$axios.post(
          `${API_URL_PREFIX}/landings/${form.landing}/forms/`,
          {
            name: form.name,
            success_text: form.success_text,
            button_text: form.button_text,
            landing: form.landing
          }
        );
        form.id = data.id;
        form.items.map(item => {
          item.form = form.id;
        });
        await this.$axios.patch(
          `${API_URL_PREFIX}/landings/${form.landing}/forms/${form.id}`,
          form
        );
        await this.$router.push({
          name: "Forms",
          query: { landing_id: form.landing }
        });
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
        this.setErrors(response.data);
      }
    },
    getCurrentLandingId() {
      return this.$route.query.landing_id;
    }
  }
};
</script>
